import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from '../../Services/translation';
import {
    GenericGridRow,
    GenericGridHeader,
    GenericGridSettings,
    GenericGridPagination,
} from '.';
import { getURLSearchParams } from '../../Services/url';

// const MOCK_FIELD_IDS = {
//     editableFieldIds: ['variantName', 'PartWeightPackage'],
//     identifierFieldId: 'variantId',
// };

/**
 *
 * @param {boolean} isLoading - State of data fetching for the grid.
 * @param {Array} dataRows - Data rows for the grid.
 * @param {Object} settings - Global grid settings.
 */
export const GenericGridView = ({
    isLoading = false,
    dataRows = [],
    settings = {},
    onSettingsChange,
    onRowChange,
}) => {
    const hasRows = (dataRows || []).length > 0;
    const { totalHits, pageSize } = settings;
    const pageCount = Math.ceil(totalHits / pageSize) || 1;
    const { page = 1 } = getURLSearchParams();
    return (
        <div className="generic-grid-view">
            <GenericGridSettings onChange={onSettingsChange} {...settings} />
            {isLoading && !hasRows && (
                <Fragment>
                    <p className="generic-grid-view--loading">{translate('common.genericgridview.loadingtext')}</p>
                    <div className="generic-loader active"></div>
                </Fragment>
            )}
            <div className="generic-grid-view__grid">
                {hasRows ? (
                    <table
                        className={classNames('generic-grid-view__table', {
                            'is-loading': isLoading,
                        })}
                    >
                        <GenericGridHeader {...dataRows[0]} />
                        <tbody>
                            {dataRows.map((row, index) => (
                                <GenericGridRow
                                    key={index}
                                    {...row}
                                    {...settings}
                                    onChange={onRowChange}
                                    rowIndex={index}
                                />
                            ))}
                        </tbody>
                    </table>
                ) : !isLoading ? (
                        <div className="generic-grid-view__no-result">{translate('common.genericgridview.noresult')}</div>
                ) : null}
            </div>
            {pageCount > 1 && (
                <GenericGridPagination
                    total={pageCount}
                    current={Number(page)}
                    onChange={(page) => onSettingsChange({ page })}
                />
            )}
        </div>
    );
};

GenericGridView.propTypes = {
    isLoading: PropTypes.bool,
    dataRows: PropTypes.arrayOf(PropTypes.object),
    settings: PropTypes.object,
    onSettingsChange: PropTypes.func,
    onRowChange: PropTypes.func,
};

GenericGridView.displayName = 'GenericGridView';
